<template lang="pug">
#game-loading.fixed.inset-0.from-login-bg-from.to-login-bg-to.flex.items-center.justify-center(v-if="fullScreen", class="z-[111]")
  img(:src="loadingImg", alt="Loading", class="w-38 h-38", @error="onLoadingError")
img.mx-auto.my-auto(v-else, :src="loadingImg", alt="Loading", :class="[imgClass || 'w-38 h-38']", @error="onLoadingError")
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

import { useNuxtApp } from '#app'

const { $SoundControl } = useNuxtApp()

const { getBackCdnUrl, getFrontCdnUrl } = useCdnAssets()

const props = defineProps({
  fullScreen: {
    type: Boolean,
    default: true,
  },
  localImg: {
    type: Boolean,
    default: false,
  },
  withSound: {
    type: Boolean,
    default: false,
  },
  imgClass: {
    type: String,
    default: '',
  },
})

const loadingImg = ref('')

const onLoadingError = () => {
  const fallbackImg = getFrontCdnUrl('images/common/common_animation_loading_normal.webp')
  if (loadingImg.value !== fallbackImg) {
    loadingImg.value = fallbackImg
  }
}

onMounted(() => {
  loadingImg.value = props.localImg
    ? getFrontCdnUrl('images/common/common_animation_loading_normal.webp')
    : getBackCdnUrl('icon/loading_animation.webp')

  if (props.withSound) {
    $SoundControl.background.play('loading')
  }
})

onBeforeUnmount(() => {
  if (props.withSound) {
    $SoundControl.background.play('lobby')
  }
})
</script>

<style lang="scss" scoped>
#game-loading {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
